import React from 'react';
import { EtapaInformacoesProps } from './types';
import { formatarCategoria } from './utils';

const EtapaInformacoes: React.FC<EtapaInformacoesProps> = ({
  formData,
  onInputChange,
  unidades,
  searchTerm,
  filteredUnidades,
  isDropdownOpen,
  onSearchChange,
  onSelectUnidade,
  onPreencherResponsavel,
  onAplicarSugestao,
  gerarSugestao,
  slideDirection
}) => {
  return (
    <div style={{
      animation: slideDirection === 'right' ? 'slideInRight 0.3s ease-out' : 'slideInLeft 0.3s ease-out'
    }}>
      <div className="mb-4">
        <label className="form-label fw-semibold mb-2" style={{ fontSize: '14px', color: '#495057' }}>
          Categoria dos Editais
        </label>
        <input
          type="text"
          className="form-control modern-input"
          value={formatarCategoria(formData.categoria)}
          disabled
          style={{ backgroundColor: '#f8f9fa', cursor: 'not-allowed' }}
        />
      </div>
      <div className="mb-4">
        <label className="form-label fw-semibold mb-2" style={{ fontSize: '14px', color: '#495057' }}>
          Identificador do Processo
        </label>
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            className="form-control modern-input"
            value={formData.identificador}
            onChange={(e) => onInputChange('identificador', e.target.value)}
            placeholder="Digite o identificador único"
            style={{ paddingRight: formData.categoria ? '200px' : '14px' }}
          />
          {formData.categoria && (
            <button
              type="button"
              onClick={onAplicarSugestao}
              style={{
                position: 'absolute',
                right: '8px',
                top: '50%',
                transform: 'translateY(-50%)',
                border: 'none',
                background: 'transparent',
                color: '#0d6efd',
                fontSize: '12px',
                cursor: 'pointer',
                padding: '4px 8px',
                borderRadius: '4px',
                transition: 'all 0.2s',
                whiteSpace: 'nowrap'
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            >
              <i className="bi bi-lightbulb me-1"></i>
              Sugestão: {gerarSugestao()}
            </button>
          )}
        </div>
      </div>
      <div className="mb-4">
        <label className="form-label fw-semibold mb-2" style={{ fontSize: '14px', color: '#495057' }}>
          Responsável
        </label>
        <div className="input-group">
          <input
            type="text"
            className="form-control modern-input"
            style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            value={formData.responsavel}
            onChange={(e) => onInputChange('responsavel', e.target.value)}
            placeholder="Nome do responsável"
          />
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onPreencherResponsavel}
            style={{ borderTopRightRadius: '8px', borderBottomRightRadius: '8px', borderLeft: 0 }}
          >
            <i className="bi bi-person-fill me-1"></i>
            Eu
          </button>
        </div>
      </div>
      <div style={{ position: 'relative' }}>
        <label className="form-label fw-semibold mb-2" style={{ fontSize: '14px', color: '#495057' }}>
          Unidade/Órgão
        </label>
        <input
          type="text"
          className="form-control modern-input"
          placeholder="Buscar unidade ou órgão"
          value={searchTerm}
          onChange={onSearchChange}
        />
        {isDropdownOpen && filteredUnidades.length > 0 && (
          <div className="dropdown-menu show" style={{ 
            width: '100%', 
            maxHeight: '200px', 
            overflowY: 'auto',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            marginTop: '4px'
          }}>
            {filteredUnidades.map((unidade) => (
              <button
                key={unidade.id}
                type="button"
                className="dropdown-item"
                onClick={() => onSelectUnidade(unidade)}
                style={{ padding: '10px 14px' }}
              >
                {unidade.nome}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EtapaInformacoes;
